module.exports = __webpack_public_path__ + "img/download_review.e528d402.svg";